import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type TLkType } from '@/app/shared/types/lkType';
import { type IUser } from '@/app/shared/types/user';

export type TUserData = IUser & {
  lkType: TLkType | null;
};

const initialState = {
  isAuthenticated: false,
  lkType: null,
} as TUserData;

export const { reducer: userReducer, actions: userActions } = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (_state, action: PayloadAction<TUserData>) => action.payload,
  },
});
